module.exports = function() {
  return new Worker(__webpack_public_path__ + "6f3df3afd6dfc8f47eb0.worker.js");
};